(() => {
  const reviewLabels = [
    ['.jdgm-cancel-rev', 'Cancel Review'],
    ['.close-form-btn', 'Cancel Review'],
    ['.jdgm-form__title', 'Write a Review'],
    ['.jdgm-write-rev-link', 'Write a Review'],
  ];
  const applyReviewLabels = (root = document) => {
    reviewLabels.forEach(([selector, text]) => {
      if (root.matches?.(selector) && root.textContent !== text) {
        root.textContent = text;
      }
      root.querySelectorAll?.(selector).forEach((element) => {
        if (element.textContent !== text) element.textContent = text;
      });
    });
  };
  const initReviewLabels = () => {
    applyReviewLabels();
    const pendingRoots = new Set();
    let frameId = null;
    const flushReviewLabels = () => {
      pendingRoots.forEach(applyReviewLabels);
      pendingRoots.clear();
      frameId = null;
    };
    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        if (record.target.nodeType === Node.ELEMENT_NODE) pendingRoots.add(record.target);
        record.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) pendingRoots.add(node);
        });
      });
      if (frameId === null) frameId = window.requestAnimationFrame(flushReviewLabels);
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => {
      observer.disconnect();
      if (frameId !== null) window.cancelAnimationFrame(frameId);
      flushReviewLabels();
    }, 10000);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewLabels, { once: true });
  } else {
    initReviewLabels();
  }
})();
